import axiosInstance from '@/libs/axios'
import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import acquirerCostConfigMaintain from './acquirer-cost-config-maintain'

const getInitialState = () => ({
  ...storePagination.state(),
  costConfigs: [],
  filters: { name: '', acquirer: '', status: '' },
})

export default {
  namespaced: true,
  state: getInitialState(),

  modules: { acquirerCostConfigMaintain },

  mutations: {
    ...storePagination.mutations,

    SET_COST_CONFIGS(state, costConfigs) {
      state.costConfigs = costConfigs
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, costConfigs } = getInitialState()
      state.filters = filters
      state.paging = paging
      state.costConfigs = costConfigs
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchCostConfigs({ commit, state }) {
      const { data } = await axiosInstance.get('/api/settings/financial/acquirer-cost-configs', {
        params: {
          name: state.filters.name,
          acquirer: state.filters.acquirer,
          active: state.filters.status,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_COST_CONFIGS', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },

    async activateCostConfig(_, id) {
      await axiosInstance.patch(`/api/settings/financial/acquirer-cost-configs/${id}/activate`)
    },

    async deactivateCostConfig(_, id) {
      await axiosInstance.patch(`/api/settings/financial/acquirer-cost-configs/${id}/deactivate`)
    },

    async duplicateCostConfig(_, { id, name }) {
      await axiosInstance.post(`/api/settings/financial/acquirer-cost-configs/${id}/duplicate`, name)
    },

    async deleteCostConfig(_, id) {
      await axiosInstance.delete(`/api/settings/financial/acquirer-cost-configs/${id}`)
    },

    setFilters({ commit }, filters) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
